import {
    NavBarCategory,
    NavBarCategoryMetadata,
    NavBarRoute,
    NavBarRouteMetadata
} from "../../../core/models/users.models";

export const navBarRouteMetadata: { [key in NavBarRoute]: NavBarRouteMetadata } = {
    [NavBarRoute.care_chat]: {
        name: 'Chats',
        route: NavBarRoute.care_chat,
        category: NavBarCategory.care,
        icon: 'curelink:chat',
        order: 2
    },
    [NavBarRoute.care_dashboard]: {
        name: 'Dashboard',
        route: NavBarRoute.care_dashboard,
        category: NavBarCategory.care,
        icon: 'curelink:dashboard',
        order: 1
    },
    [NavBarRoute.care_tasks]: {
        name: 'Tasks',
        route: NavBarRoute.care_tasks,
        category: NavBarCategory.care,
        icon: 'curelink:task',
        order: 3
    },
    [NavBarRoute.care_patients]: {
        name: 'Patients',
        route: NavBarRoute.care_patients,
        category: NavBarCategory.care,
        icon: 'curelink:patient',
        order: 4
    },
    [NavBarRoute.care_renewals]: {
        name: 'Renewals',
        route: NavBarRoute.care_renewals,
        category: NavBarCategory.care,
        icon: 'curelink:renewal',
        order: 5
    },
    [NavBarRoute.care_patient_assignment]: {
        name: 'Patient Assignment',
        route: NavBarRoute.care_patient_assignment,
        category: NavBarCategory.care,
        icon: 'curelink:patient_assignment',
        order: 6
    },
    [NavBarRoute.care_query_assignment]: {
        name: 'Query Assignment',
        route: NavBarRoute.care_query_assignment,
        category: NavBarCategory.care,
        icon: 'curelink:query_assignment',
        order: 7
    },
    [NavBarRoute.care_diet_chart_template_management]: {
        name: 'Template Management',
        route: NavBarRoute.care_diet_chart_template_management,
        category: NavBarCategory.care,
        icon: 'curelink:template_management',
        order: 8
    },
    [NavBarRoute.care_whatsapp_chat]: {
        name: 'WhatsApp Chats',
        route: NavBarRoute.care_whatsapp_chat,
        category: NavBarCategory.care,
        icon: 'curelink:whatsapp_chat',
        order: 9
    },
    [NavBarRoute.care_refer_patients]: {
        name: 'Refer Patients',
        route: NavBarRoute.care_refer_patients,
        category: NavBarCategory.care,
        icon: 'curelink:prescribe_patient',
        order: 10
    },
    [NavBarRoute.sessions_calendar]: {
        name: 'Calendar',
        route: NavBarRoute.sessions_calendar,
        category: NavBarCategory.sessions,
        icon: 'curelink:session_calendar',
        order: 1
    },
    [NavBarRoute.sessions_standalone]: {
        name: 'Standalone',
        route: NavBarRoute.sessions_standalone,
        category: NavBarCategory.sessions,
        icon: 'curelink:standalone_session',
        order: 2
    },
    [NavBarRoute.sessions_course]: {
        name: 'Course',
        route: NavBarRoute.sessions_course,
        category: NavBarCategory.sessions,
        icon: 'curelink:course_session',
        order: 3
    },
    [NavBarRoute.sessions_recurring]: {
        name: 'Recurring',
        route: NavBarRoute.sessions_recurring,
        category: NavBarCategory.sessions,
        icon: 'curelink:recurring_session',
        order: 4
    },
    [NavBarRoute.sessions_tasks]: {
        name: 'Tasks',
        route: NavBarRoute.sessions_tasks,
        category: NavBarCategory.sessions,
        icon: 'curelink:task',
        order: 5
    },
    [NavBarRoute.sessions_batches]: {
        name: 'My Batches',
        route: NavBarRoute.sessions_batches,
        category: NavBarCategory.sessions,
        icon: 'curelink:batches',
        order: 6
    },
    [NavBarRoute.sessions_patients]: {
        name: 'New Patients',
        route: NavBarRoute.sessions_patients,
        category: NavBarCategory.sessions,
        icon: 'curelink:patient',
        order: 7
    },
    [NavBarRoute.sessions_patient_transfer]: {
        name: 'Patient Activity',
        route: NavBarRoute.sessions_patient_transfer,
        category: NavBarCategory.sessions,
        icon: 'curelink:patient_transfer',
        order: 8
    },
    [NavBarRoute.sessions_special_consultation_tasks]: {
        name: 'Special Consults',
        route: NavBarRoute.sessions_special_consultation_tasks,
        category: NavBarCategory.sessions,
        icon: 'curelink:task',
        order: 9
    },
    [NavBarRoute.sessions_webinars]: {
        name: 'My Webinars',
        route: NavBarRoute.sessions_webinars,
        category: NavBarCategory.sessions,
        icon: 'curelink:batches',
        order: 10
    },
    [NavBarRoute.tools_edit_message_template]: {
        name: 'Edit Msg. Template',
        route: NavBarRoute.tools_edit_message_template,
        category: NavBarCategory.tools,
        icon: 'curelink:edit_message_template',
        order: 1
    },
    [NavBarRoute.tools_send_message_template]: {
        name: 'Send Msg. Template',
        route: NavBarRoute.tools_send_message_template,
        category: NavBarCategory.tools,
        icon: 'curelink:send_message_template',
        order: 2
    },
    [NavBarRoute.tools_upload_assets]: {
        name: 'Upload Assets',
        route: NavBarRoute.tools_upload_assets,
        category: NavBarCategory.tools,
        icon: 'curelink:upload_assets',
        order: 3
    },
    [NavBarRoute.tools_knowledge_base]: {
        name: 'Knowledge Base',
        route: NavBarRoute.tools_knowledge_base,
        category: NavBarCategory.tools,
        icon: 'curelink:knowledge_base',
        order: 4
    },
    [NavBarRoute.tools_whatsapp_login]: {
        name: 'WhatsApp Login',
        route: NavBarRoute.tools_whatsapp_login,
        category: NavBarCategory.tools,
        icon: 'curelink:whatsapp_login',
        order: 5
    },
    [NavBarRoute.tools_query_review]: {
        name: 'Query Review',
        route: NavBarRoute.tools_query_review,
        category: NavBarCategory.tools,
        icon: 'curelink:query_review',
        order: 6
    },
    [NavBarRoute.doctors_prescribe_patient]: {
        name: 'Prescribe Patient',
        route: NavBarRoute.doctors_prescribe_patient,
        category: NavBarCategory.doctors,
        icon: 'curelink:prescribe_patient',
        order: 1
    },
    [NavBarRoute.doctors_feedbacks]: {
        name: 'Patient Feedbacks',
        route: NavBarRoute.doctors_feedbacks,
        category: NavBarCategory.doctors,
        icon: 'curelink:feedbacks',
        order: 2
    },
    [NavBarRoute.doctors_profile]: {
        name: 'Doctor Profiles',
        route: NavBarRoute.doctors_profile,
        category: NavBarCategory.doctors,
        icon: 'curelink:patient',
        order: 3
    },
    [NavBarRoute.doctors_send_notification]: {
        name: 'Send App Notification',
        route: NavBarRoute.doctors_send_notification,
        category: NavBarCategory.doctors,
        icon: 'curelink:send_notification',
        order: 4
    },
    [NavBarRoute.sales_tasks]: {
        name: 'Tasks',
        route: NavBarRoute.sales_tasks,
        category: NavBarCategory.sales,
        icon: 'curelink:task',
        order: 1
    },
    [NavBarRoute.sales_patients]: {
        name: 'Patients',
        route: NavBarRoute.sales_patients,
        category: NavBarCategory.sales,
        icon: 'curelink:patient',
        order: 2
    },
    [NavBarRoute.sales_chat]: {
        name: 'Chats',
        route: NavBarRoute.sales_chat,
        category: NavBarCategory.sales,
        icon: 'curelink:chat',
        order: 3
    },
    [NavBarRoute.sales_whatsapp_chat]: {
        name: 'WhatsApp Chats',
        route: NavBarRoute.sales_whatsapp_chat,
        category: NavBarCategory.sales,
        icon: 'curelink:whatsapp_chat',
        order: 4
    },
}

export const navBarCategoryMetadata: { [key in NavBarCategory]: NavBarCategoryMetadata } = {
    [NavBarCategory.care]: {
        name: 'Care',
        category: NavBarCategory.care,
        order: 1
    },
    [NavBarCategory.sales]: {
        name: 'Sales',
        category: NavBarCategory.sales,
        order: 2
    },
    [NavBarCategory.doctors]: {
        name: 'Doctor Ops.',
        category: NavBarCategory.doctors,
        order: 3
    },
    [NavBarCategory.sessions]: {
        name: 'Sessions',
        category: NavBarCategory.sessions,
        order: 4
    },
    [NavBarCategory.tools]: {
        name: 'Tools',
        category: NavBarCategory.tools,
        order: 5
    },
}
